import {
  USER_PLAN_REQUEST,
  USER_PLAN_REQUEST_FAILED,
  USER_PLAN_REQUEST_SUCCEED,
} from "../actions/app";

const initialState = {
  inProgress: false,
  data: null,
};

export const userPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PLAN_REQUEST:
      return { ...state, inProgress: true, data: null };
    case USER_PLAN_REQUEST_SUCCEED:
      return { ...state, inProgress: false, data: action.payload };
    case USER_PLAN_REQUEST_FAILED:
      return { ...state, inProgress: false, error: action.payload };
    default:
      return state;
  }
};
